if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.filtersComponent = document.querySelector('facet-filters');
      this.filtersColumn = document.querySelector('.main-products-grid__filters');
      this.seriesToggle = this.querySelector('#series-view-switch');
      this.sortBy = this.querySelector('.products-toolbar__sort');
      this.productsGrid = document.querySelector('.main-products-grid');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.js-toggle-filters');
        this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
      }

      if (this.seriesToggle) {
        this.seriesToggle.addEventListener('change', this.handleSeriesChange.bind(this));
        const savedLayout = Shopify.designMode ? null : theme.storageUtil.get('products-layout');
        const layout = savedLayout === 'grid' || savedLayout === 'list'
          ? savedLayout
          : this.productsGrid.dataset.defaultLayout || 'grid';
        this.setLayout(layout, false);
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
      }
    }

    /**
     * Toggles open/closed state of the filters on desktop.
     */
    toggleFilters() {
      this.filterToggle.classList.toggle('is-active');
      this.filtersOpen = this.filterToggle.classList.contains('is-active');
      this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

      if (theme.mediaMatches.lg) {
        this.filtersColumn.classList.toggle('lg:js-hidden', !this.filtersOpen);
        const productsList = document.querySelector('.main-products-grid__results > .grid');

        productsList.className = this.filtersOpen
          ? productsList.dataset.filtersOpenClasses
          : productsList.dataset.filtersClosedClasses;
      } else {
        this.filtersComponent.open();
      }
    }

    /**
     * Handles changes to the View As Series switch.
     * @param {object} evt - Change event object.
     */
    handleSeriesChange(evt) {
      this.setLayout(evt.target.checked ? 'list' : 'grid', true);
    }

    /**
     * Applies the collection representation.
     * @param {string} layout - 'grid' for variant cards or 'list' for parent series rows.
     * @param {boolean} persist - Whether to remember the customer's selection.
     */
    setLayout(layout, persist) {
      const nextLayout = layout === 'list' ? 'list' : 'grid';
      this.productsGrid.dataset.layout = nextLayout;
      this.seriesToggle.checked = nextLayout === 'list';
      this.seriesToggle.setAttribute('aria-checked', String(this.seriesToggle.checked));
      if (persist && !Shopify.designMode) theme.storageUtil.set('products-layout', nextLayout);
    }

    /**
     * Handles when a sort by dropdown is changed (and filtering is disabled)
     * @param {object} evt - Event object.
     */
    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'products-toolbar';
      window.location.href = urlObj.toString();
    }
  }

  customElements.define('products-toolbar', ProductsToolbar);
}
